import jwt from '../../http/requests/auth/jwt/index.js';
import axios from '@/axios';

export default {
  addDiscount(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .saveHttpDiscount(data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  getDiscountDetails(_context, id){
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpDiscount(id)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  getDiscountList(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpDiscountList(data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  fetchDiscountList() {
    return new Promise((resolve, reject) => {
      jwt
        .fetchAllHttpDiscount()
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  updateDiscountDetails(_context,data){
    return new Promise((resolve,reject)=>{
      jwt
        .updateHttpDiscountDetail(data)
        .then((res) => {
          resolve(res);
        }).catch(err =>{
        reject(err);
      });
    });
  },
  deleteDiscountById(_context,id){
    return new Promise((resolve, reject) => {
      jwt
        .deleteHttpDiscount(id)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  bulkDiscountList(_context, data) {
    return axios.get('/api/v1/admins/discounts', { params: data });
  },
  createBulkDiscount(_context, data) {
    return axios.post('/api/v1/admins/discounts', data);
  },
  deleteBulkDiscount(_context, id) {
    return axios.delete(`/api/v1/admins/discounts/${id}`);
  },
  updateBulkDiscount(_context, data) {
    return axios.put(`/api/v1/admins/discounts/${data.id}`, data.body);
  },
  getBulkDiscountDetails(_context, id) {
    return axios.get(`/api/v1/admins/discounts/${id}`);
  },
  getBulkDiscountGroups(_context, data) {
    return axios.get('/api/v1/admins/discounts/groups', { params: data });
  },
  createBulkDiscountGroup(_context, data) {
    return axios.post('/api/v1/admins/discounts/groups', data);
  },
  updateBulkDiscountGroup(_context, data) {
    return axios.put(`/api/v1/admins/discounts/groups/${data.id}`, data.body);
  },
  deleteBulkDiscountGroup(_context, id) {
    return axios.delete(`/api/v1/admins/discounts/groups/${id}`);
  },
};
